"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const LocationSystemIcon = props => {
  const {
      size = 24
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "LOCATION-SYSTEM-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M12 0a8.25 8.25 0 0 1 8.25 8.25c0 2.965-3.594 9.945-7 15.08a1.5 1.5 0 0 1-2.5 0c-3.406-5.135-7-12.115-7-15.08A8.25 8.25 0 0 1 12 0Zm0 1.5a6.75 6.75 0 0 0-6.75 6.75c0 2.537 3.536 9.406 6.75 14.25 3.214-4.844 6.75-11.713 6.75-14.25A6.75 6.75 0 0 0 12 1.5m0 2.25a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 1.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
  })));
};
LocationSystemIcon.displayName = "LocationSystemIcon";
LocationSystemIcon.iconName = "Location";
export default LocationSystemIcon;